// Editable content for the trainer site. Swap text/images anytime.
export const TRAINER = {
  name: "Ricardo Jurado",
  business: "Jurado Performance",
  role: "Strength & Conditioning Coach",
  tagline: ["Train with purpose.", "Live with confidence."],
  location: "Annapolis, Maryland",
  credentials: ["NASM Certified Personal Trainer", "U.S. Army Veteran"],
  email: "Ricardojuradocpt@gmail.com",
  phone: "+1 (860) 882-9290",
  instagram: "@juradoperformance",
  googleUrl: "https://www.google.com/maps",
  heroImage:
    "/hero-retouched.jpg",
  portrait:
    "https://customer-assets-lxgj4vgw.emergentagent.net/job_fit-connect-48/artifacts/gyqz8eim_J.png",
  bio: [
    "At Jurado Performance, I help you build strength, lose weight, gain confidence and create healthier habits through personalized one-on-one and semi-private training. Every program is tailored to your goals, fitness level and lifestyle \u2014 because no two people are the same.",
    "My coaching is built on The Jurado Standard: accountability, professionalism, proper technique and a commitment to results that last. Let\u2019s work towards a better tomorrow.",
  ],
  stats: [
    { value: "10", label: "Years Coaching" },
    { value: "100%", label: "Personalized Plans" },
    { value: "5.0", label: "Google Rating" },
  ],
};

export const MARQUEE = [
  "STRENGTH", "DISCIPLINE", "FOCUS", "MOBILITY", "LONGEVITY", "POWER", "CONSISTENCY",
];

export const MANIFESTO = [
  {
    n: "01",
    title: "Train the person, not the program",
    body: "Cookie-cutter plans break people. Everything I build bends to your life, your history and your goals \u2014 then evolves as you do.",
  },
  {
    n: "02",
    title: "Strength is a skill you can learn",
    body: "You are not too old, too injured or too far gone. Strength responds to intelligent, patient effort at any starting point.",
  },
  {
    n: "03",
    title: "Consistency beats intensity",
    body: "The workout you can repeat for years will always outperform the one that wrecks you for a week. We play the long game.",
  },
  {
    n: "04",
    title: "Recovery is where you grow",
    body: "Sleep, food and stress are not afterthoughts. We coach the full 24 hours, not just the hour in the gym.",
  },
];

export const SERVICES = [
  {
    title: "1:1 & 2:1 Personal Training",
    desc: "In-person coaching built around your body and goals \u2014 train solo, or bring a partner for 2:1 sessions. Hands-on cueing, real accountability, measurable progress.",
    points: ["Fully tailored programming", "Ongoing program adjustments", "Form & technique mastery"],
    featured: true,
  },
  {
    title: "Online Coaching",
    desc: "Train anywhere with a plan delivered to your phone, plus video form checks and direct messaging with me.",
    points: ["App-based training", "Video form feedback", "24/7 messaging"],
  },
  {
    title: "Nutrition Coaching",
    desc: "A sustainable, flexible approach to fuelling your training \u2014 no banned foods, no misery.",
    points: ["Habit-based nutrition", "Macro guidance", "Ongoing adjustments"],
  },
];

export const GALLERY = [
  "https://images.pexels.com/photos/17706040/pexels-photo-17706040.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  "https://images.pexels.com/photos/3912944/pexels-photo-3912944.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  "https://images.unsplash.com/photo-1734630341082-0fec0e10126c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2MzR8MHwxfHNlYXJjaHwyfHxneW0lMjB3ZWlnaHRzJTIwZHJhbWF0aWMlMjBkYXJrfGVufDB8fHx8MTc4NTc2Nzc1Mnww&ixlib=rb-4.1.0&q=85",
  "https://images.unsplash.com/photo-1548690312-e3b507d8c110?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxNzV8MHwxfHNlYXJjaHwxfHxmaXRuZXNzJTIwdHJhaW5lciUyMHBvcnRyYWl0JTIwZGFya3xlbnwwfHx8fDE3ODU3Njc3Mzd8MA&ixlib=rb-4.1.0&q=85",
];

export const ARTICLES = [
  {
    tag: "Training Science",
    title: "Why progressive overload is the key to real strength",
    summary:
      "Progressive overload \u2014 steadily increasing the demand you place on your muscles \u2014 is the foundation of every effective resistance-training program. Without it, your body has no reason to keep adapting. The good news: research shows you can drive it by adding load or by adding repetitions, and both produce comparable muscle growth, while heavier loads give a slight edge for maximal strength. That\u2019s exactly how we program at Jurado Performance: train with intent, take your sets close to true effort, and progress consistently, week over week.",
    sources: [
      {
        label:
          "Plotkin D, Coleman M, Van Every D, et al. \u201CProgressive overload without progressing load? The effects of load or repetition progression on muscular adaptations.\u201D PeerJ (2022) 10:e14142. \u2014 Lehman College (CUNY), Renaissance Periodization & Northwestern University.",
        url: "https://pmc.ncbi.nlm.nih.gov/articles/PMC9528903/",
      },
      {
        label: "National Academy of Sports Medicine (NASM). \u201CProgressive Overload Explained.\u201D NASM Blog.",
        url: "https://blog.nasm.org/progressive-overload-explained",
      },
    ],
  },
  {
    tag: "Healthy Aging",
    title: "Strength training keeps you strong as you age",
    summary:
      "From about age 35 we naturally start losing muscle and strength \u2014 a process called sarcopenia that speeds up later in life and threatens mobility and independence. The reassuring news from decades of NIH-funded research: resistance training can slow, and even partly reverse, that decline at any age. Just one to two strength sessions a week, paired with regular walking, helps preserve muscle, bone density and balance, lowers fall risk, and keeps you doing the everyday things you love for longer. It\u2019s never too late to start.",
    sources: [
      {
        label:
          "National Institute on Aging (NIH). \u201CHow can strength training build healthier bodies as we age?\u201D (June 30, 2022). Featuring research from Tufts University, Baylor College of Medicine & Wake Forest University.",
        url: "https://www.nia.nih.gov/news/how-can-strength-training-build-healthier-bodies-we-age",
      },
    ],
  },
  {
    tag: "Conditioning",
    title: "HIIT: bigger results in less time",
    summary:
      "High-intensity interval training alternates short, hard efforts with brief recovery \u2014 and the science backs it up. A 2021 peer-reviewed review found that HIIT delivers similar, and sometimes greater, improvements in cardiorespiratory fitness (VO\u2082max), endurance and metabolic health compared with longer moderate-intensity cardio, despite a lower total training volume. That makes it a time-efficient, highly effective way to build conditioning and heart health \u2014 which is why we weave smart intervals into Jurado Performance programming.",
    sources: [
      {
        label:
          "Atakan MM, Li Y, Ko\u015Far \u015EN, Turnag\u00F6l HH, Yan X. \u201CEvidence-Based Effects of High-Intensity Interval Training on Exercise Capacity and Health: A Review with Historical Perspective.\u201D Int. J. Environ. Res. Public Health (2021) 18(13):7201.",
        url: "https://pmc.ncbi.nlm.nih.gov/articles/PMC8294064/",
      },
    ],
  },
];

// Fallback reviews shown until live Google Reviews are configured.
export const FALLBACK_REVIEWS = [
  { author_name: "Sarah K.", rating: 5, relative_time_description: "2 months ago", text: "Ricardo completely changed how I think about training. I'm stronger at 41 than I was at 25. Genuinely life-changing coaching." },
  { author_name: "Devin R.", rating: 5, relative_time_description: "5 months ago", text: "Rehabbed a nagging shoulder and hit a lifetime deadlift PR in the same block. He actually listens and adjusts." },
  { author_name: "Priya M.", rating: 5, relative_time_description: "1 month ago", text: "The nutrition coaching alone was worth it. No crazy diet, just sustainable habits that finally stuck." },
];
